import React from "react";

import { faSparkles } from "@fortawesome/pro-solid-svg-icons";

import { Divider } from "../../../components/Divider";
import { SuggestedActions } from "./SuggestedActions";

import { FORM_BUILDING_COACH_START_QUERY } from "../constants";

type FormBuilderSuggestedActionsProps = {
	showSuggestQuestions: boolean;
	showSuggestImprovements: boolean;
	onSelectSuggestQuestions: (query: string) => void;
	onSelectSuggestImprovements: (query: string) => void;
};

export const FormBuilderSuggestedActions: React.FC<FormBuilderSuggestedActionsProps> = ({
	showSuggestQuestions,
	showSuggestImprovements,
	onSelectSuggestQuestions,
	onSelectSuggestImprovements,
}) => {
	return (
		<div className="flex flex-col">
			{showSuggestQuestions && (
				<SuggestedActions
					size="large"
					actions={[
						{
							label: "Suggest questions for me",
							icon: faSparkles,
							onClick: () => onSelectSuggestQuestions("Suggest questions to ask"),
						},
					]}
				/>
			)}
			{showSuggestQuestions && showSuggestImprovements && <Divider />}
			{showSuggestImprovements && (
				<SuggestedActions
					size="large"
					actions={[
						{
							label: "Suggest improvements for my form",
							icon: faSparkles,
							onClick: () => onSelectSuggestImprovements(FORM_BUILDING_COACH_START_QUERY),
						},
					]}
				/>
			)}
		</div>
	);
};
